// src/features/settings/LoginSecurityCommon.jsx
import React from "react";
import TopBar from "@/sot/primitives/TopBar.jsx";
import { Link } from "react-router-dom";
import SettingsChevron from "@/sot/primitives/SettingsChevron.jsx";
import { useLanguage } from "@/contexts/LanguageContext.jsx";
import Card from "@/components/ui/Card.jsx";

export default function LoginSecurityCommon({
  withTopBar = false,
  onBack,
  basePath = "/settings/patient/login-security",
}) {
  const { t } = useLanguage();
  const passwordPath = `${basePath}/change-password`;
  const changeLabel = t("common.change", "Change");
  const passwordActionLabel = changeLabel;
  const twoFactorLabel = t(
    "settings.loginSecurity.twoFactor.label",
    "Two factor authentication",
  );
  const cardClass = [
    "overflow-hidden rounded-[12px]",
    "bg-[rgb(var(--clr-surface-cont-highest))]",
  ]
    .filter(Boolean)
    .join(" ");
  const rowBase =
    "flex h-14 items-center px-4 gap-3 text-body-large text-on-surface";

  const trailingBase = "ml-auto text-body-large";

  return (
    <>
      {withTopBar && (
        <TopBar
          title={t("settings.home.loginSecurity", "Account & Security")}
          onBack={onBack ?? (() => history.back())}
        />
      )}

      {/* sits inside the 720px shell provided by the screen wrapper */}
      <div className="mt-5">
        <Card className="overflow-hidden p-0">
          {/* Password */}
          <div>
            <Link
              to={passwordPath}
              className={rowBase}
              aria-label={t("settings.loginSecurity.password.aria", "Change password")}
            >
              <div>{t("settings.loginSecurity.password.label", "Password")}</div>
              <span className={trailingBase + " text-primary"}>{passwordActionLabel}</span>
            </Link>
            <div className="ml-4 h-px bg-[var(--Schemes-Outline-Variant,#E6E7EB)]" />
          </div>

          {/* Passcode */}
          <div>
            <Link
              to={`${basePath}/change-passcode`}
              className={rowBase}
              aria-label={t("settings.loginSecurity.passcode.aria", "Change passcode")}
            >
              <div>{t("settings.loginSecurity.passcode.label", "Passcode")}</div>
              <span className={trailingBase + " text-primary"}>{changeLabel}</span>
            </Link>
            <div className="ml-4 h-px bg-[var(--Schemes-Outline-Variant,#E6E7EB)]" />
          </div>

          {/* 2FA */}
          <div>
            <Link
              to={`${basePath}/two-factor`}
              className={rowBase}
              aria-label={t(
                "settings.loginSecurity.twoFactor.aria",
                "Two factor authentication",
              )}
            >
              <div>{twoFactorLabel}</div>
              <div className="ml-auto flex items-center gap-2 text-label-large text-on-surface-var">
                <SettingsChevron className="text-on-surface-var opacity-70" />
              </div>
            </Link>
          </div>
        </Card>
      </div>
    </>
  );
}
